import React from 'react';
import ReactDOM from 'react-dom';

import ubBanzai from 'ub/control/banzai-features';
import FormFontPicker from 'ub/fonts/font-picker/form/form-field-label/font-picker';
import formStateController from 'ub/fonts/font-picker/form/form-field-label/state-controller';
import CheckboxFontPicker from 'ub/fonts/font-picker/form/form-checkbox/font-picker';
import checkboxStateController from 'ub/fonts/font-picker/form/form-checkbox/state-controller';

const getFontAttribute = (formElementModel, attribute, defaultValue) => {
  if (formElementModel.exists(attribute)) {
    return formElementModel.get(attribute);
  } else {
    return defaultValue;
  }
};

const setDefaultFont = (formElementPropertiesPanelInstance, formElementModel, element) => {

  if (ubBanzai.features.isFontPickerEnabled()) {
    formElementPropertiesPanelInstance
      .syncUIControls(formElementPropertiesPanelInstance.element);
  } else {
    formElementPropertiesPanelInstance
      .controls
      .labelFont
      .setValue({
        family: getFontAttribute(formElementModel, `style.${element}.font.family`, 'arial'),
        weight: getFontAttribute(formElementModel, `style.${element}.font.weight`, 'normal')
      });
  }
};


const installFieldLabelFontPicker = (formElementPropertiesPanelInstance, labelAttrsPanel) => {
  if (ubBanzai.features.isFontPickerEnabled()) {
    const fontPickerContainer = document.createElement('div');

    fontPickerContainer.className = 'panel-content font-picker';

    labelAttrsPanel.e.insert(fontPickerContainer);

    ReactDOM.render(
      React.createElement(FormFontPicker),
      fontPickerContainer
    );

    formStateController.setActiveElement(formElementPropertiesPanelInstance.element);
  } else {
    formElementPropertiesPanelInstance.controls.labelFont =
      labelAttrsPanel.insertContent(
        formElementPropertiesPanelInstance._labelUIBinding.mkFormFontInput(
          {
            label: 'Font',
            showSize: false
          }
        )); // Emits a `changeFont` event to label UI binding
  }
};

const installCheckboxFontPicker = (formElementPropertiesPanelInstance, checkboxAttrsPanel) => {
  if (ubBanzai.features.isFontPickerEnabled()) {
    const fontPickerContainer = document.createElement('div');

    fontPickerContainer.className = 'panel-content font-picker';

    checkboxAttrsPanel.e.insert(fontPickerContainer);

    ReactDOM.render(
      React.createElement(CheckboxFontPicker),
      fontPickerContainer
    );

    checkboxStateController.setActiveElement(formElementPropertiesPanelInstance.element);
  } else {
    formElementPropertiesPanelInstance.controls.cbxLabelFont =
      checkboxAttrsPanel.insertContent(
        formElementPropertiesPanelInstance._checkboxUIBinding.mkFormFontInput(
          {
            label: 'Font',
            showSize: false
          }
        )); // Emits a `changeFont` event to checkbox UI binding
  }
};

const updateLabelFont = (formElementPropertiesPanelInstance, formElementModel) => {
  if (ubBanzai.features.isFontPickerEnabled()) {
    formStateController.setActiveElement(formElementPropertiesPanelInstance.element);
  } else {
    formElementPropertiesPanelInstance.controls.labelFont.setValue({
      family: getFontAttribute(formElementModel, 'style.label.font.family', 'arial'),
      weight: getFontAttribute(formElementModel, 'style.label.font.weight', 'normal')
    });
  }
};

const updateCheckboxFont = (formElementPropertiesPanelInstance, formElementModel) => {
  if (ubBanzai.features.isFontPickerEnabled()) {
    checkboxStateController.setActiveElement(formElementPropertiesPanelInstance.element);
  } else {
    formElementPropertiesPanelInstance.controls.cbxLabelFont.setValue({
      family: getFontAttribute(formElementModel, 'style.cbxlabel.font.family', 'arial'),
      weight: getFontAttribute(formElementModel, 'style.cbxlabel.font.weight', 'normal')
    });
  }
};

const updateCheckboxFontWeight = (formElementPropertiesPanelInstance, formElementModel) => {
  if (ubBanzai.features.isFontPickerEnabled()) {
    formStateController.setActiveElement(formElementPropertiesPanelInstance.element);
  } else {
    formElementPropertiesPanelInstance.controls.labelFont.setValue({
      family: getFontAttribute(formElementModel, 'style.label.font.family', 'arial'),
      weight: getFontAttribute(formElementModel, 'style.label.font.weight', 'normal')
    });
  }
};

export default {
  setDefaultFont,
  installFieldLabelFontPicker,
  installCheckboxFontPicker,
  updateLabelFont,
  updateCheckboxFont,
  updateCheckboxFontWeight
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/form/installation-helper.js